import video from 'globalCommon/utils/video';
import { showCustomImage } from 'globalCommon/utils/index';
import { UserLogoMap } from '../common/utils/imageSource';
import commonPageService from 'pcCommon/services/commonPageService';
import { IUserInfo } from 'globalCommon/services/getUserInfo';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';

function callback(userInfo: IUserInfo) {
    if (userInfo && userInfo.umu_id) {
        const tryNow: any = document.querySelector('.a-operation.try-now');
        tryNow && (tryNow.href = '/');
    }
}

function init() {
    showCustomImage(UserLogoMap, 'client-show');
    commonPageService({ cb: callback, renderAfter: syncRender });
    video.init();
}

init();
